import {
    EDIT_RETAILER_FAILED,
    EDIT_RETAILER_LOADING,
    EDIT_RETAILER_SUCCESS,
    GET_ALLRETAILER_REMOVE,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status: null,
  };
  
  export const editRetailerReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any, status:any }
  ) => {
    switch (action.type) {
      case EDIT_RETAILER_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
          status: null,
        };
      case EDIT_RETAILER_SUCCESS:
        return {
          ...state,
          loading: false,
          status: action.status,
        };
      case EDIT_RETAILER_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status: null,
        };
        case GET_ALLRETAILER_REMOVE:
          return initialState;
      default:
        return state;
    }
  };
  